import { render, staticRenderFns } from "./form-info.vue?vue&type=template&id=5ade50c6&"
import script from "./form-info.vue?vue&type=script&lang=js&"
export * from "./form-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports